if (!window.carouselHeroes) { // Only run once
  window.carouselHeroes = [];
  const itemClass = 'carousel-item';

  const createInitialSwiper = () => {
    // Important: Don't let swiper init until we've set config.
    const swiper = document.createElement('swiper-container');
    Object.assign(swiper, {
      // init: false,
      loop: false, // NOTE: Protects falling fruit init event
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true
      },
    });

    // If we want init = false, we'll need to run some things after
    // const swiperParams = {
    //   loop: false,
    //   navigation: {
    //     clickable: true,
    //     disabledClass: "opacity-30 pointer-events-none",
    //     prevEl: swiperParent.querySelector(`.prev`),
    //     nextEl: swiperParent.querySelector(`.next`),
    //   },
    //   pagination: {
    //     el: swiperParent.querySelector('.fraction'),
    //     type: "fraction",
    //   },
    // };

    // Object.assign(swiper, swiperParams);
    // swiper.initialize();

    return swiper;
  }

  const wrapInSwiperContainerInParent = (item) => {
    const parent = document.createElement('swiper-parent');
    parent.classList.add('relative');

    const hasControls = item.childElementCount > 1;
    const controls = document.createElement('div');

    if (hasControls) {
      // TODO: Enagle and style controls
      // controls.innerHTML = `<div class="absolute bottom-8 left-half -translate-x-half text-white flex items-center gap-4 z-[2] rounded-full py-4 px-6">
      //   <a class="prev" href="#">
      //     ${chevronUseSvg()}
      //   </a>
      //   <span class="fraction min-w-10 text-center"></span>
      //   <a class="next" href="#">
      //     ${chevronUseSvg('right')}
      //   </a>
      // </div>`;

      parent.appendChild(controls);
    }

    parent.append(item);
    return parent;
  }

  const wrapInSwiperSlide = (item) => {
    const slide = document.createElement('swiper-slide');
    slide.append(item);
    return slide;
  }

  const wrapSequentialCarouselItems = (context = document, classToTarget = itemClass) => {
    // Array to collect consecutive carousel items that need wrapping
    let consecutiveCarouselItems = [];
    // Create a document fragment to hold our new structure temporarily
    const fragment = document.createDocumentFragment();

    // Process all child elements
    const children = Array.from(context.children);

    for (let i = 0; i < children.length; i++) {
      const child = children[i];

      if (child.classList.contains(classToTarget)) {
        // Add to collection of consecutive carousel items
        consecutiveCarouselItems.push(child);
      } else {
        // If we have carousel items collected, wrap them before adding this non-carousel element
        if (consecutiveCarouselItems.length > 0) {
          // Create swiper container for collected carousel items
          const swiperContainer = createInitialSwiper();

          // Move all collected carousel items into the swiper container
          consecutiveCarouselItems.forEach(carouselItem => swiperContainer.appendChild(wrapInSwiperSlide(carouselItem)));

          // Add the swiper container to our fragment
          fragment.appendChild(wrapInSwiperContainerInParent(swiperContainer));

          // Reset collection for next potential group
          consecutiveCarouselItems = [];
        }

        // Add the non-carousel element to our fragment
        fragment.appendChild(child);
      }
    }

    // Handle any remaining consecutive carousel items at the end
    if (consecutiveCarouselItems.length > 0) {
      const swiperContainer = createInitialSwiper();
      consecutiveCarouselItems.forEach(carouselItem => swiperContainer.appendChild(wrapInSwiperSlide(carouselItem)));
      fragment.appendChild(wrapInSwiperContainerInParent(swiperContainer));
    }

    // Clear the original div by moving all elements to the fragment first
    // (this avoids creating new elements and preserves the original ones)
    while (context.firstChild) {
      context.removeChild(context.firstChild);
    }

    // Add all our processed nodes back to the parent
    context.appendChild(fragment);

    return context;
  }

  const isFirstChild = element => {
    if (!element || !element.parentNode) return false;

    const parent = element.parentNode;
    for (let i = 0; i < parent.childNodes.length; i++) {
      const child = parent.childNodes[i];
      if (child.nodeType === 1) return child === element;
    }

    return false;
  };

  const chevronUseSvg = (dir = 'left') => {
    return `<svg width="24" height="24" viewBox="0 0 24 24">
      <use href="#chevron-${dir}-use" />
    </svg>`;
  }

  document.addEventListener("DOMContentLoaded", () => {
    wrapSequentialCarouselItems(document.getElementById('MainContent'), itemClass);

    const swiperItems = [...document.querySelectorAll('#MainContent > swiper-container, #MainContent > swiper-parent')];

    // Add page topper class
    swiperItems.forEach(item => {
      if (isFirstChild(item)) {
        item.classList.add('page-topper');
      }
    });

    window.carouselHeroes = [
      ...window.carouselHeroes,
      ...swiperItems
    ];
  });
}

